/* ------------------------------------------------------------------
   Estate Sale Landing — shared lot behaviors
   Loaded (deferred) by every estate-sale lot section. Handles:
   - countdown timers   [data-esl-countdown] / [data-esl-timer]
   - detail panels      [data-esl-detail-toggle] / [data-esl-detail]
   - add to cart        [data-esl-add-to-cart]
   ------------------------------------------------------------------ */
(function () {
  if (window.__eslLotInit) return;
  window.__eslLotInit = true;

  /* ── Countdowns ─────────────────────────────────────────────────── */

  var timerItems = [];
  var timerLoop = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var now = Date.now();
    timerItems.forEach(function (item) {
      var d = Math.max(0, item.t - now);
      var h = Math.floor(d / 3600000);
      var m = Math.floor((d % 3600000) / 60000);
      var s = Math.floor((d % 60000) / 1000);
      item.el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    });
  }

  function collectTimers() {
    document.querySelectorAll('[data-esl-countdown]').forEach(function (el) {
      if (el.__eslBound) return;
      el.__eslBound = true;
      var t = Date.parse(el.getAttribute('data-deadline') || '');
      if (isNaN(t)) {
        var chip = el.closest('[data-esl-timer]');
        if (chip) chip.style.display = 'none';
      } else {
        timerItems.push({ el: el, t: t });
      }
    });
    if (timerItems.length) {
      tick();
      if (!timerLoop) timerLoop = setInterval(tick, 1000);
    }
  }

  collectTimers();
  document.addEventListener('shopify:section:load', collectTimers);

  /* ── Detail panels + add to cart (capture-phase delegation) ─────── */

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var navButton = target.closest('[data-esl-carousel-prev], [data-esl-carousel-next]');
      if (navButton) {
        var wrap = navButton.closest('[data-esl-carousel]');
        var track = wrap && wrap.querySelector('[data-esl-carousel-track]');
        if (track) {
          var slide = track.firstElementChild;
          var step = slide ? slide.getBoundingClientRect().width + 32 : track.clientWidth * 0.5;
          track.scrollBy({
            left: navButton.hasAttribute('data-esl-carousel-prev') ? -step : step,
            behavior: 'smooth'
          });
        }
        return;
      }

      var closeButton = target.closest('[data-esl-detail-close]');
      if (closeButton) {
        var openPanel = closeButton.closest('[data-esl-detail]');
        if (openPanel) {
          event.preventDefault();
          openPanel.hidden = true;
          var origin = openPanel.__eslOrigin;
          if (origin && origin.scrollIntoView) {
            origin.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }

      var cartButton = target.closest('[data-esl-add-to-cart]');
      if (cartButton) {
        event.preventDefault();
        event.stopPropagation();
        if (cartButton.dataset.eslBusy) return;
        cartButton.dataset.eslBusy = '1';
        var originalLabel = cartButton.textContent;
        cartButton.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(cartButton.getAttribute('data-esl-add-to-cart')), quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add-to-cart failed');
            cartButton.textContent = 'Added';
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function () {
            cartButton.textContent = 'Error';
          })
          .then(function () {
            setTimeout(function () {
              cartButton.textContent = originalLabel;
              delete cartButton.dataset.eslBusy;
            }, 1600);
          });
        return;
      }

      var link = target.closest('[data-esl-detail-toggle]');
      if (!link) return;
      var section = link.closest('.esl-lot');
      if (!section) return;

      var key = link.getAttribute('data-esl-detail-toggle');
      var panels = section.querySelectorAll('[data-esl-detail]');
      var panel = null;
      panels.forEach(function (p) {
        if (p.getAttribute('data-esl-detail') === key) panel = p;
      });
      if (!panel) return; /* no panel for this item: link goes to the PDP */

      event.preventDefault();
      event.stopPropagation();
      panels.forEach(function (p) { p.hidden = true; });
      panel.hidden = false;
      panel.__eslOrigin = link.closest('.esl-lot__item, .esl-lot2__large, .esl-lot5__row') || link;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    true
  );
})();
